import {
  HEADERS,
  ROWS,
} from 'containers/admin/clients/client/tabs-components/goals-tab/goals-tab.constants';

export const getPathToGoal = (path: string): string => {
  const pathSegments = path.split('/').filter((segment) => segment !== '');

  if (pathSegments.length > 0) {
    pathSegments.pop();
  }

  const newPath = `/${pathSegments.join('/')}`;

  return newPath;
};

export const getLastPathSegment = (path: string): number | '' => {
  const pathSegments = path.split('/').filter((segment) => segment !== '');

  return pathSegments.length ? +pathSegments[pathSegments.length - 1] : '';
};

export interface PrepareGoalPayloadParams {
  userId: string | number | undefined;
  clientId: string | number | undefined;
  data: {
    id?: string | number;
    category?: string;
    type?: string;
    enteringClassYear?: number;
  };
  formData: Record<string, unknown> & {
    value?: string | number;
    relativeToLastYear?: unknown;
    note?: unknown;
    summary?: unknown;
    subType?: unknown;
    funnelMetric?: unknown;
    name?: unknown;
    description?: unknown;
    details: Array<{
      category?: string;
      options?: string | string[];
      [key: string]: unknown;
    }>;
  };
}

export const prepareGoalPayload = ({
  userId,
  clientId,
  data,
  formData,
}: PrepareGoalPayloadParams): Record<string, unknown> => {
  const id = Number(data.id) || undefined;

  const payload = {
    userId,
    clientId,
    id,
    goalData: {
      category: data.category,
      type: data.type,
      id,
      enteringClassYear: data.enteringClassYear,
      value: Number(formData.value),
      relativeToLastYear: formData.relativeToLastYear,
      note: formData.note,
      summary: formData.summary,
      ...(formData.subType ? { subType: formData.subType } : {}),
      ...(formData.funnelMetric ? { funnelMetric: formData.funnelMetric } : {}),
      name: formData.name,
      description: formData.description,
      details: formData.details.map((item) => ({
        ...item,
        options: item.options ? ([] as string[]).concat(item.options) : [],
        category: item.category || data.category,
      })),
    },
  };

  return payload;
};

export interface GetUrlParamsInput {
  goalType?: string;
  goalCategory?: string;
  year?: string | number;
  goalId?: string;
  clientId?: string;
}

export interface UrlParamsResult {
  type: string | undefined;
  category: string | undefined;
  enteringClassYear: number;
  goalId: string | undefined;
  clientId: string | undefined;
}

export const getUrlParams = ({
  goalType,
  goalCategory,
  year,
  goalId,
  clientId,
}: GetUrlParamsInput): UrlParamsResult => ({
  type: goalType ? HEADERS[goalType] : undefined,
  category: goalCategory ? ROWS[goalCategory] : undefined,
  enteringClassYear: Number(year),
  goalId,
  clientId,
});

export interface PathSegmentsResult {
  goalType: string | undefined;
  goalCategory: string | undefined;
}

export const getPathSegmentsFromValues = ({
  type,
  category,
}: {
  type?: string;
  category?: string;
}): PathSegmentsResult => ({
  goalType: Object.keys(HEADERS).find((key) => HEADERS[key] === type),
  goalCategory: Object.keys(ROWS).find((key) => ROWS[key] === category),
});
